import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_LATVIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Numurs', 'Kartes numurs'],
    cardExpiry: ['Derīgums', 'Beigu datums'],
};

export const TUI_LATVIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Populāri',
        history: 'Nesenie',
        placeholder: 'Meklēt',
        hotkey: 'lai meklētu',
        all: 'Visi',
        empty: 'Nav rezultātu',
    },
};

export const TUI_LATVIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Atcelt',
    done: 'Gatavs',
    more: 'Vairāk',
    otherDate: 'Cits datums...',
    showAll: 'Rādīt visu',
    hide: 'Slēpt',
    mobileCalendarTexts: [
        'Izvēlieties dienu',
        'Izvēlieties periodu',
        'Izvēlieties dienas',
    ],
    range: ['No', 'Līdz'],
    countTexts: ['Vairāk', 'Mazāk'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'diena.mēnesis.gads',
        MDY: 'mēnesis.diena.gads',
        YMD: 'gads.mēnesis.diena',
    },
    digitalInformationUnits: ['Baits', 'Kilobaits', 'Megabaits'],
    passwordTexts: ['Rādīt paroli', 'Slēpt paroli'],
    copyTexts: ['Kopēt', 'Nokopēts'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mai',
        'Jūn',
        'Jūl',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dec',
    ],
    pagination: ['Iepriekšējā lapa', 'Nākamā lapa'],
    fileTexts: {
        loadingError: 'Ielādes kļūda',
        preview: 'Priekšskatījums',
        remove: 'Noņemt',
    },
    inputFileTexts: {
        defaultLabelSingle: 'vai nomest to šeit',
        defaultLabelMultiple: 'vai nomest tos šeit',
        defaultLinkSingle: 'Atlasīt failu',
        defaultLinkMultiple: 'Atlasīt failus',
        maxSizeRejectionReason: 'Fails ir pārāk liels',
        formatRejectionReason: 'Nederīgs faila formāts',
        drop: 'Nomest failu šeit',
        dropMultiple: 'Nomest failus šeit',
    },
    multiSelectTexts: {
        all: 'Atlasīt visus',
        none: 'Atlasīt nevienu',
    },
    confirm: {
        yes: 'Jā',
        no: 'Nē',
    },
    previewTexts: {
        rotate: 'Pagriezt',
    },
    zoomTexts: {
        zoomOut: 'Attālināt',
        zoomIn: 'Pietuvināt',
        reset: 'Atiestatīt',
    },
    phoneSearch: 'Meklēt valsti vai kodu',
};

export const TUI_LATVIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Vienkrāsains', 'Krāsu gradients'],
    toolbarTools: {
        undo: 'Atsaukt',
        redo: 'Atkārtot',
        font: 'Fonts',
        fontStyle: 'Fonta stils',
        fontSize: 'Fonta izmērs',
        bold: 'Treknraksts',
        italic: 'Kursīvs',
        underline: 'Pasvītrots',
        strikeThrough: 'Pārsvītrots',
        justify: 'Izlīdzināt',
        justifyLeft: 'Izlīdzināt pa kreisi',
        justifyCenter: 'Centrēt',
        justifyRight: 'Izlīdzināt pa labi',
        justifyFull: 'Izlīdzināt abas malas',
        list: 'Saraksts',
        indent: 'Palielināt atkāpi',
        outdent: 'Samazināt atkāpi',
        unorderedList: 'Nenumurēts saraksts',
        orderedList: 'Numurēts saraksts',
        quote: 'Citāts',
        foreColor: 'Teksta krāsa',
        backColor: 'Fona krāsa',
        hiliteColor: 'Iezīmēšanas krāsa',
        clear: 'Notīrīt',
        link: 'Saite',
        attach: 'Pievienot failu',
        tex: 'Ievietot TeX',
        code: 'Kods',
        image: 'Ievietot attēlu',
        insertHorizontalRule: 'Ievietot horizontālu līniju',
        superscript: 'Augšraksts',
        subscript: 'Apakšraksts',
        insertTable: 'Ievietot tabulu',
        insertGroup: 'Ievietot grupu',
        hiliteGroup: 'Iezīmēt grupu',
        removeGroup: 'Noņemt grupu',
        insertAnchor: 'Ievietot enkuru',
        mergeCells: 'Apvienot šūnas',
        splitCells: 'Sadalīt šūnas',
        rowsColumnsManaging: 'Pārvaldīt rindas un kolonnas',
        cellColor: 'Šūnas krāsa',
        setDetails: 'Iestatīt detaļas',
        removeDetails: "Noņemt detaļas",
    },
    editorEditLink: {
        urlExample: 'piemērs.com',
        anchorExample: 'enkurs',
    },
    editorTableCommands: [
        ['Ievietot kolonnu pirms', 'Ievietot kolonnu pēc'],
        ['Ievietot rindu pirms', 'Ievietot rindu pēc'],
        ['Noņemt kolonnu', 'Noņemt rindu'],
    ],
    editorCodeOptions: ['Kods tekstā', 'Koda bloks'],
    editorFontOptions: {
        small: 'Mazs',
        large: 'Liels',
        normal: 'Normāls',
        title: 'Virsraksts',
        subtitle: 'Apakšvirsraksts',
    },
};

export const TUI_LATVIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Rādīt/Slēpt',
    paginationTexts: {
        pages: 'Lapas',
        linesPerPage: 'Rindas lapā',
        of: 'no',
    },
};

export const TUI_LATVIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Janvāris',
        'Februāris',
        'Marts',
        'Aprīlis',
        'Maijs',
        'Jūnijs',
        'Jūlijs',
        'Augusts',
        'Septembris',
        'Oktobris',
        'Novembris',
        'Decembris',
    ],
    close: 'Aizvērt',
    clear: 'Notīrīt',
    nothingFoundMessage: 'Nekas nav atrasts',
    defaultErrorMessage: 'Nederīga vērtība',
    spinTexts: ['Iepriekšējais', 'Nākamais'],
    shortWeekDays: ['Pir', 'Otr', 'Tre', 'Cet', 'Pie', 'Ses', 'Svē'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_LATVIAN_LANGUAGE: TuiLanguage = {
    name: 'latvian',
    ...TUI_LATVIAN_LANGUAGE_CORE,
    ...TUI_LATVIAN_LANGUAGE_KIT,
    ...TUI_LATVIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_LATVIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_LATVIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_LATVIAN_LANGUAGE_LAYOUT,
};